import React from "react";

import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Skeleton from "@material-ui/lab/Skeleton";

import { makeStyles } from "@material-ui/core/styles";
import { green, grey } from '@material-ui/core/colors';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import moment from 'moment';

import Rating from '@material-ui/lab/Rating';
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === "dark";

  return {
    on: {
      color: green[600],
      fontSize: '20px'
    },
    off: {
      color: isDark ? grey[400] : grey[600],
      fontSize: '20px'
    },
    pointer: {
      cursor: "pointer"
    },
    tableContainer: {
      borderRadius: 12,
      border: isDark ? "1px solid rgba(148,163,184,0.15)" : "1px solid rgba(15,23,42,0.08)",
      boxShadow: isDark ? "0 2px 8px rgba(0,0,0,0.2)" : "0 1px 3px rgba(15,23,42,0.05)",
      overflow: "hidden",
      backgroundColor: isDark ? "#1e293b" : "#ffffff",
    },
    tableHead: {
      backgroundColor: isDark ? "rgba(15,23,42,0.6)" : "rgba(248,250,252,0.95)",
    },
    headCell: {
      fontWeight: 700,
      fontSize: "0.8rem",
      color: isDark ? "#f8fafc" : "#0f172a",
    },
    bodyCell: {
      color: isDark ? "#e2e8f0" : "#334155",
    },
    rowEven: {
      backgroundColor: isDark ? "rgba(15,23,42,0.25)" : "rgba(248,250,252,0.6)",
    },
    rowOdd: {
      backgroundColor: "transparent",
    },
  };
});

export function RatingBox({ rating }) {
    const ratingTrunc = rating === null ? 0 : Math.trunc(rating);
    return <Rating
        defaultValue={ratingTrunc}
        max={3}
        readOnly
    />
}

export default function TableAttendantsStatus(props) {
    const { loading, attendants } = props
    const classes = useStyles();

    function renderList() {
        return attendants.map((a, k) => (
            <TableRow key={k} className={k % 2 === 0 ? classes.rowOdd : classes.rowEven}>
                <TableCell className={classes.bodyCell} style={{ fontWeight: 600 }}>{a.name}</TableCell>
                <TableCell align="center" className={classes.bodyCell}>{a.rating}</TableCell>
                <TableCell align="center" className={classes.bodyCell}>{a.countRating}</TableCell>
                <TableCell align="center" className={classes.bodyCell}>{a.tickets}</TableCell>
                <TableCell align="center" className={classes.bodyCell}>{formatTime(a.avgWaitTime, 2)}</TableCell>
                <TableCell align="center" className={classes.bodyCell}>{formatTime(a.avgSupportTime, 2)}</TableCell>
                <TableCell align="center" className={classes.bodyCell}>
                    {a.online ?
                        <Tooltip title="Online">
                            <CheckCircleIcon className={classes.on} />
                        </Tooltip>
                        :
                        <Tooltip title="Offline">
                            <ErrorIcon className={classes.off} />
                        </Tooltip>
                    }
                </TableCell>
            </TableRow>
        ))
    }

    function formatTime(minutes) {
        return moment().startOf('day').add(minutes, 'minutes').format('HH[h] mm[m]');
    }

    return (!loading ?
        <TableContainer component={Paper} className={classes.tableContainer} elevation={0}>
            <Table size="small">
                <TableHead>
                    <TableRow className={classes.tableHead}>
                        <TableCell className={classes.headCell}>{i18n.t("dashboard.users.name")}</TableCell>
                        <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.assessments.score")}</TableCell>
                        <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.assessments.ratedCalls")}</TableCell>
                        <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.assessments.totalCalls")}</TableCell>
                        <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.cards.averageWaitingTime")}</TableCell>
                        <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.cards.averageServiceTime")}</TableCell>
                        <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.cards.status")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {renderList()}
                </TableBody>
            </Table>
        </TableContainer>
        : <Skeleton variant="rect" height={150} />
    )
}
